<template>
  <div>
    <MultiselectDropdown
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.TYPE.LABEL')"
        :error="$v.coupon.kind_index.$error ? $t('COUPON.ADD_FORM.TYPE_FORM.TYPE.ERROR'):''"
    >
        <RadioList
            :classWrapper="'couponOptions'"
            v-model="coupon.kind_index"
            :options="kinds"
        />
    </MultiselectDropdown>

        <!-- v-if="kinds && kinds[coupon.kind_index].id === 'unique'" -->
    <ToggleField
        v-if="kinds && isUniquekind"
        v-model="uniqueQR"
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.QR_CODE.LABEL')"
        :hint="'sample hint'"
        @onToggle="onToggleUniqueQR"
    />

    <InputField
        v-model="coupon.name"
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.NAME.LABEL')"
        :placeholder="$t('COUPON.ADD_FORM.TYPE_FORM.NAME.PLACEHOLDER')"
        :error="$v.coupon.name.$error ? $t('COUPON.ADD_FORM.TYPE_FORM.NAME.ERROR') : ''"
        :infoList="[]"
        :hint="$t('COUPON.ADD_FORM.TYPE_FORM.NAME.HINT')"
        @blur="$v.coupon.name.$touch"
    />
    <InputField
        v-if="coupon.kind_index === 0"
        v-model="coupon.code"
        :disabled="coupon.id ? true : false"
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.PROMO_CODE.LABEL')"
        :placeholder="$t('COUPON.ADD_FORM.TYPE_FORM.PROMO_CODE.PLACEHOLDER')"
        :error="$v.coupon.code.$error ? $t('COUPON.ADD_FORM.TYPE_FORM.PROMO_CODE.ERROR') : ''"
        :infoList="[]"
        :hint="$t('COUPON.ADD_FORM.TYPE_FORM.PROMO_CODE.HINT')"
        @blur="$v.coupon.code.$touch"
    />
    <!-- prefix and code will be stored in same property -->
    <InputField
        v-if="coupon.kind_index === 1"
        v-model="coupon.code"
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.SERIAL_PREFIX.LABEL')"
        :placeholder="$t('COUPON.ADD_FORM.TYPE_FORM.SERIAL_PREFIX.PLACEHOLDER')"
        :error="$v.coupon.code.$error ? $t('COUPON.ADD_FORM.TYPE_FORM.SERIAL_PREFIX.ERROR') : ''"
        :infoList="[]"
        @blur="$v.coupon.code.$touch"
    />

    <MultiselectDropdown
        v-if="coupon.id"
        :label="$t('COUPON.EDIT_FORM.STATUS.LABEL')"
    >
        <multiselect
            class="column small-12"
            v-model="coupon.status"
            :options="status_list"
            track-by="id"
            label="title"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="false"
            :placeholder="$t('COUPON.EDIT_FORM.STATUS.PLACEHOLDER')"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
        />
    </MultiselectDropdown>

    <MultiselectDropdown
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.PRODUCT.LABEL')"
        :hint="coupon.products.length ?`${coupon.products.length} items selected`:''"
    >
        <!-- :error="$v.coupon.products.$error ? $t('COUPON.ADD_FORM.TYPE_FORM.PRODUCT.ERROR') : ''" -->
        <multiselect
             ref="productMultiselect"
            class="column small-12"
            v-model="coupon.selected_product_option"
            :options="product_btns"
            track-by="id"
            label="title"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="false"
            :placeholder="$t('COUPON.ADD_FORM.TYPE_FORM.PRODUCT.PLACEHOLDER')"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
        >
            <!-- @select="onProductBtnSelect" -->
         <template #option="{ option }">
                <!-- @click="onProductBtnSelect(option)" -->
            <div
            >
            <!-- {{ option.title }} -->
                <div class="product_option" @click.stop="onClickProductOption(option)">{{option.title}}</div>
            </div>
        </template>
        </multiselect>
    </MultiselectDropdown>



    <!--
        <InputField
            v-model="coupon.templates.title"
            :label="$t('COUPON.ADD_FORM.TYPE_FORM.TITLE.LABEL')"
            :placeholder="$t('COUPON.ADD_FORM.TYPE_FORM.TITLE.PLACEHOLDER')"
            :error="$v.coupon.templates.title.$error ? $t('COUPON.ADD_FORM.TYPE_FORM.TITLE.ERROR') : ''"
            :infoList="[]"
            @blur="$v.coupon.templates.title.$touch"
        />
    -->
    <InputField
        v-model="coupon.templates.footer"
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.FOOTER.LABEL')"
        :placeholder="$t('COUPON.ADD_FORM.TYPE_FORM.FOOTER.PLACEHOLDER')"
        :error="$v.coupon.templates.footer.$error ? $t('COUPON.ADD_FORM.TYPE_FORM.FOOTER.ERROR') : ''"
        :infoList="[]"
        @blur="$v.coupon.templates.footer.$touch"
    />
    <div v-if="coupon.img_file && coupon.img_file.preview_url">
        <img class="preview_image" :src="coupon.img_file.preview_url" alt="">
    </div>
    <MultiselectDropdown
        :label="$t('COUPON.ADD_FORM.TYPE_FORM.IMG.LABEL')"
        :infoList="[]"
    >
        <input
            ref="file"
            type="file"
            accept="image/*,"
            @change="handleImageUpload"
        />
    </MultiselectDropdown>
    <div class="submit_btns">
        <woot-button
            color-scheme="primary" size="small" :style="{width:'100%'}"
            :is-loading="false"
            :is-disabled="false"
            @click="onNext"
        >
           {{$t('COUPON.ADD_FORM.TYPE_FORM.BTNS.NEXT')}}
          </woot-button>
    </div>

    <SelectProductsModal
        :isOpen="isProductModalOpen"
        :onClose="onCloseProductModal"
        :products="coupon.products"
    />

  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import alertMixin from 'shared/mixins/alertMixin';
import methodHelperMixin from '../../../../../mixins/methodHelperMixin';
import Spinner from 'shared/components/Spinner.vue';
import RadioList from "../../../../dashboard/arrange/RadioList.vue"
import MultiselectDropdown from "../../../../../components/ui/inputs/MultiselectDropdown.vue"
import InputField from '../../../../../components/ui/inputs/InputField.vue';
import ToggleField from '../../../../../components/ui/inputs/ToggleField.vue';
import SelectProductsModal from "./SelectProductsModal.vue";



export default {
    components: {
        RadioList,
        MultiselectDropdown,
        InputField,
        ToggleField,
        SelectProductsModal,
    },
    mixins: [alertMixin,methodHelperMixin],
    props:{
        coupon:{
            type: Object,
        },
        kinds:{
            type: Array,
            default: []
        },
        status_list:{
            type: Array,
            default: []
        },
    },
    data(){
        return {
            uniqueQR: false,
            isProductModalOpen:false,
        }
    },
    computed:{
        product_btns(){
            return [
                {id:'all',title: this.$t('COUPON.ADD_FORM.TYPE_FORM.PRODUCT.LIST.ALL')},
                {id:'custom',title: this.$t('COUPON.ADD_FORM.TYPE_FORM.PRODUCT.LIST.CUSTOM') },
            ]
        },
        isUniquekind(){
            return this.kinds[this.coupon?.kind_index]?.id === 'unique';
        },
    },
    validations:{
        coupon:{
            kind_index:{
                required
            },
            name:{
                required
            },
            code:{
                required
            },
            templates:{
                // title:{
                //     required
                // },
                footer:{
                    required
                },
            },

        },
    },
    methods:{
        onNext(){
            this.$v.$touch();
            if (this.$v.$invalid) {
                console.log(this.$v);
                return;
            }
            const nextStep = 2;
            this.$emit('onNext', nextStep)
        },
        onToggleUniqueQR(value){
            this.uniqueQR = value;
        },
        onOpenProductModal(){
            this.isProductModalOpen = true;
        },
        onCloseProductModal(){
            this.isProductModalOpen = false;
        },
        async onClickProductOption(option){
            console.log({option});
            if (option.id === 'all') {
                this.coupon.products= [];
            }else if (option.id === 'custom') {
                this.onOpenProductModal();
            }
            await this.$nextTick();
            this.coupon.selected_product_option = option;

            // Close dropdown programmatically
            this.$refs.productMultiselect.deactivate(); // This closes the dropdown
        },
        async handleImageUpload(event) {
            console.log("up img");
            const newFile = event.target.files[0];
            // coupon.templates.image
            // this.coupon.image_file = event.target.files[0];
            // this.coupon.templates.image = event.target.files[0];

            if (newFile?.size > 1024 * 1024 * 40) {
                this.showAlert('File is too big. Please select file of size less then 40mb.');
                this.$refs.file.value = null;
                this.coupon.img_file.preview_url = '';
            }
            // compress and resize the image
            if (newFile) {
                const resizedImage = await this.resizeImage(event.target.files[0], { maxWidth: 500, maxHeight: 500 });
                // console.log({resizedImage,original:event.target.files[0]});
                const compressedImage = await this.compressImage(resizedImage, { maxSizeKB: 800, initialQuality: 0.9, qualityStep: 0.1 });
                this.coupon.img_file.new_upload = compressedImage;
                console.log({compressedImage});
                // this.image_preview_url = await this.getImagePreviewUrl(compressedImage);
                this.coupon.img_file.preview_url = await this.getImagePreviewUrl(compressedImage);
            }
                // console.log(this.image_preview_url,123);
        },
        // end methods
    },
}
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.couponOptions{
    /* margin-top: 4px; */
    display: flex;
    gap: 24px;
}

.preview_image{
    display: block;
    width: 200px;
    border-radius: 10px;
    margin: auto;
}

.submit_btns{
    margin-top: 24px;
}

</style>

<style>
.couponOptions .radio-item{
    gap: 0;
}
.couponOptions .radio_label_wrap{
    margin-bottom: 2px;
}
.couponOptions .radio_label{
    font-weight: 500;
    color: #304352;
}
.couponOptions .radio_description{
    font-weight: 500;
    color: #858585;
    font-size: 12px;
}
</style>